import XLSXStyle from "xlsx-js-style";

const COLOR_MARCA = "00BFD6";
const RENGLONES_EN_BLANCO = 30;

const COLUMNAS_MOTIVOS = [
  { titulo: "Etapa", clave: "etapa", ancho: 30 },
  { titulo: "Orden", clave: "orden", ancho: 10 },
  { titulo: "Nombre", clave: "nombre", ancho: 45 },
];

const bordeFino = { style: "thin", color: { rgb: "BFBFBF" } };
const bordes = { top: bordeFino, bottom: bordeFino, left: bordeFino, right: bordeFino };

const estiloTitulo = {
  font: { bold: true, sz: 14, color: { rgb: "FFFFFF" } },
  fill: { fgColor: { rgb: COLOR_MARCA } },
  alignment: { horizontal: "center", vertical: "center" },
};
const estiloEncabezado = {
  font: { bold: true, sz: 11, color: { rgb: "1A3A4A" } },
  fill: { fgColor: { rgb: "D6F4F8" } },
  alignment: { horizontal: "center", vertical: "center", wrapText: true },
  border: bordes,
};
const estiloCelda = { border: bordes, alignment: { vertical: "center" } };

const celda = (valor) => ({ v: valor === undefined || valor === null ? "" : valor, t: typeof valor === "number" ? "n" : "s", s: estiloCelda });

const hojaConTitulo = (titulo, columnas, filas) => {
  const aoa = [
    [{ v: titulo, t: "s", s: estiloTitulo }, ...columnas.slice(1).map(() => ({ v: "", s: estiloTitulo }))],
    columnas.map((columna) => ({ v: columna.titulo, t: "s", s: estiloEncabezado })),
    ...filas.map((fila) => fila.map(celda)),
  ];
  const hoja = XLSXStyle.utils.aoa_to_sheet(aoa);
  hoja["!cols"] = columnas.map((columna) => ({ wch: columna.ancho }));
  hoja["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: columnas.length - 1 } }];
  hoja["!rows"] = [{ hpt: 24 }];
  return hoja;
};

const nombreArchivo = (texto) =>
  String(texto || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-zA-Z0-9_-]+/g, "_")
    .replace(/^_+|_+$/g, "");

export const descargarPlantillaMotivos = ({ flujo, etapas, motivos }) => {
  const etapasOrdenadas = [...etapas].sort((a, b) => (a.orden || 0) - (b.orden || 0));
  const posicionEtapa = new Map(etapasOrdenadas.map((e, i) => [e._id, i]));
  const nombreEtapa = new Map(etapasOrdenadas.map((e) => [e._id, e.nombre]));

  const filasMotivos = motivos
    .filter((m) => posicionEtapa.has(m.etapaId))
    .sort((a, b) => posicionEtapa.get(a.etapaId) - posicionEtapa.get(b.etapaId) || (a.orden || 0) - (b.orden || 0))
    .map((m) => [nombreEtapa.get(m.etapaId), m.orden, m.nombre]);
  const blancos = Array.from({ length: RENGLONES_EN_BLANCO }, () => ["", "", ""]);

  const libro = XLSXStyle.utils.book_new();
  XLSXStyle.utils.book_append_sheet(libro, hojaConTitulo(`Motivos por etapa - ${flujo.nombre}`, COLUMNAS_MOTIVOS, [...filasMotivos, ...blancos]), "Motivos");
  XLSXStyle.utils.book_append_sheet(
    libro,
    hojaConTitulo("Etapas del flujo", COLUMNAS_MOTIVOS.slice(0, 1), etapasOrdenadas.map((e) => [e.nombre])),
    "Etapas"
  );
  XLSXStyle.writeFile(libro, `Motivos_${nombreArchivo(flujo.nombre)}.xlsx`);
};

const normalizarEncabezado = (texto) =>
  String(texto || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLowerCase();

export const filasMotivosDesdeHoja = (XLSX, hoja) => {
  const crudas = XLSX.utils.sheet_to_json(hoja, { header: 1, defval: "" });
  const indiceEncabezado = crudas.findIndex((fila) => {
    const encabezados = fila.map(normalizarEncabezado);
    return encabezados.includes("etapa") && encabezados.includes("nombre");
  });
  if (indiceEncabezado === -1) return null;

  const encabezados = crudas[indiceEncabezado].map(normalizarEncabezado);
  const posicion = Object.fromEntries(COLUMNAS_MOTIVOS.map((c) => [c.clave, encabezados.indexOf(c.clave)]));

  return crudas
    .slice(indiceEncabezado + 1)
    .map((fila, indice) => ({
      fila: indiceEncabezado + indice + 2,
      etapa: String(fila[posicion.etapa] ?? "").trim(),
      orden: posicion.orden >= 0 ? fila[posicion.orden] : "",
      nombre: String(fila[posicion.nombre] ?? "").trim(),
    }))
    .filter((fila) => fila.etapa || fila.nombre);
};
